import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import View from '@loggi/ui/components/view';
import { privatePackageTrackerModel } from 'app.models';
import { locationModel } from 'app/app.models';
import getStatusPath from 'app/app.utils';
import EndContestMain from './end-contest-main.component';

export class EndContest extends Component {
  constructor(props) {
    super(props);

    const {
      privatePackageTracker: {
        packageInfo: { packageId }
      }
    } = this.props;

    this.state = {
      statusPath: getStatusPath(packageId)
    };
  }

  // Check if is the flow without Auth
  _checkUuid = () => {
    const uuid = get(this.props, 'location.state.uuid', false);
    return uuid;
  };

  _onClickGoToTracker = () => {
    const { history } = this.props;

    // Flow without authentication
    if (this._checkUuid()) {
      const {
        location: {
          state: { packageStatusPath, packageStatusSearch }
        }
      } = this.props;
      return history.replace({
        pathname: `${packageStatusPath}`,
        search: `${packageStatusSearch}`
      });
    }

    const { statusPath } = this.state;
    return history.replace(statusPath);
  };

  render() {
    const {
      privatePackageTracker: { receivedBy }
    } = this.props;

    return (
      <View className="tracker-content classificationMainView">
        <EndContestMain
          receivedBy={receivedBy}
          onClick={this._onClickGoToTracker}
        />
      </View>
    );
  }
}

EndContest.displayName = 'EndContest';

EndContest.propTypes = {
  privatePackageTracker: PropTypes.shape(privatePackageTrackerModel),
  location: PropTypes.shape(locationModel).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired
  }).isRequired
};

EndContest.defaultProps = {
  privatePackageTracker: { packageInfo: { packageId: null } }
};

function mapStateToProps(state) {
  return {
    privatePackageTracker: state.data.privatePackageTracker
  };
}

export default connect(mapStateToProps)(EndContest);
